import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    '4': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-fa4" */
        '@fortawesome/free-solid-svg-icons/fa4'
    ),
    'anchor-lock': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAnchorLock" */
        '@fortawesome/free-solid-svg-icons/faAnchorLock'
    ),
    'arrow-circle-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCircleArrowUp" */
        '@fortawesome/free-solid-svg-icons/faCircleArrowUp'
    ),
    'arrow-down-long': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLongArrowDown" */
        '@fortawesome/free-solid-svg-icons/faLongArrowDown'
    ),
    'arrow-pointer': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMousePointer" */
        '@fortawesome/free-solid-svg-icons/faMousePointer'
    ),
    'arrow-right-from-bracket': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSignOut" */
        '@fortawesome/free-solid-svg-icons/faSignOut'
    ),
    'arrow-up-1-9': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortNumericUp" */
        '@fortawesome/free-solid-svg-icons/faSortNumericUp'
    ),
    'arrow-up-from-bracket': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowUpFromBracket" */
        '@fortawesome/free-solid-svg-icons/faArrowUpFromBracket'
    ),
    'arrow-up-from-ground-water': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowUpFromGroundWater" */
        '@fortawesome/free-solid-svg-icons/faArrowUpFromGroundWater'
    ),
    'arrows-split-up-and-left': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowsSplitUpAndLeft" */
        '@fortawesome/free-solid-svg-icons/faArrowsSplitUpAndLeft'
    ),
    'band-aid': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBandage" */
        '@fortawesome/free-solid-svg-icons/faBandage'
    ),
    'bible': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBookBible" */
        '@fortawesome/free-solid-svg-icons/faBookBible'
    ),
    'bolt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faZap" */
        '@fortawesome/free-solid-svg-icons/faZap'
    ),
    'bone': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBone" */
        '@fortawesome/free-solid-svg-icons/faBone'
    ),
    'bore-hole': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBoreHole" */
        '@fortawesome/free-solid-svg-icons/faBoreHole'
    ),
    'bridge-water': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBridgeWater" */
        '@fortawesome/free-solid-svg-icons/faBridgeWater'
    ),
    'broadcast-tower': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTowerBroadcast" */
        '@fortawesome/free-solid-svg-icons/faTowerBroadcast'
    ),
    'bug': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBug" */
        '@fortawesome/free-solid-svg-icons/faBug'
    ),
    'bug-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBugSlash" */
        '@fortawesome/free-solid-svg-icons/faBugSlash'
    ),
    'burn': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFireFlameSimple" */
        '@fortawesome/free-solid-svg-icons/faFireFlameSimple'
    ),
    'cake': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCakeCandles" */
        '@fortawesome/free-solid-svg-icons/faCakeCandles'
    ),
    'calendar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCalendar" */
        '@fortawesome/free-solid-svg-icons/faCalendar'
    ),
    'calendar-day': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCalendarDay" */
        '@fortawesome/free-solid-svg-icons/faCalendarDay'
    ),
    'campground': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCampground" */
        '@fortawesome/free-solid-svg-icons/faCampground'
    ),
    'car-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCarRear" */
        '@fortawesome/free-solid-svg-icons/faCarRear'
    ),
    'car-on': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCarOn" */
        '@fortawesome/free-solid-svg-icons/faCarOn'
    ),
    'car-tunnel': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCarTunnel" */
        '@fortawesome/free-solid-svg-icons/faCarTunnel'
    ),
    'caret-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCaretDown" */
        '@fortawesome/free-solid-svg-icons/faCaretDown'
    ),
    'cent-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCentSign" */
        '@fortawesome/free-solid-svg-icons/faCentSign'
    ),
    'chair': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChair" */
        '@fortawesome/free-solid-svg-icons/faChair'
    ),
    'chart-simple': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChartSimple" */
        '@fortawesome/free-solid-svg-icons/faChartSimple'
    ),
    'check-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareCheck" */
        '@fortawesome/free-solid-svg-icons/faSquareCheck'
    ),
    'check-to-slot': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVoteYea" */
        '@fortawesome/free-solid-svg-icons/faVoteYea'
    ),
    'circle-info': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faInfoCircle" */
        '@fortawesome/free-solid-svg-icons/faInfoCircle'
    ),
    'circle-nodes': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCircleNodes" */
        '@fortawesome/free-solid-svg-icons/faCircleNodes'
    ),
    'circle-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faXmarkCircle" */
        '@fortawesome/free-solid-svg-icons/faXmarkCircle'
    ),
    'cloud': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCloud" */
        '@fortawesome/free-solid-svg-icons/faCloud'
    ),
    'cocktail': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMartiniGlassCitrus" */
        '@fortawesome/free-solid-svg-icons/faMartiniGlassCitrus'
    ),
    'colon-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faColonSign" */
        '@fortawesome/free-solid-svg-icons/faColonSign'
    ),
    'comment-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMessage" */
        '@fortawesome/free-solid-svg-icons/faMessage'
    ),
    'comments': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faComments" */
        '@fortawesome/free-solid-svg-icons/faComments'
    ),
    'concierge-bell': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faConciergeBell" */
        '@fortawesome/free-solid-svg-icons/faConciergeBell'
    ),
    'couch': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCouch" */
        '@fortawesome/free-solid-svg-icons/faCouch'
    ),
    'crop': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCrop" */
        '@fortawesome/free-solid-svg-icons/faCrop'
    ),
    'crop-simple': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCropSimple" */
        '@fortawesome/free-solid-svg-icons/faCropSimple'
    ),
    'directions': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDirections" */
        '@fortawesome/free-solid-svg-icons/faDirections'
    ),
    'drum': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDrum" */
        '@fortawesome/free-solid-svg-icons/faDrum'
    ),
    'earth-americas': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGlobeAmericas" */
        '@fortawesome/free-solid-svg-icons/faGlobeAmericas'
    ),
    'eject': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faEject" */
        '@fortawesome/free-solid-svg-icons/faEject'
    ),
    'face-meh': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMeh" */
        '@fortawesome/free-solid-svg-icons/faMeh'
    ),
    'face-meh-blank': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMehBlank" */
        '@fortawesome/free-solid-svg-icons/faMehBlank'
    ),
    'fill': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFill" */
        '@fortawesome/free-solid-svg-icons/faFill'
    ),
    'fist-raised': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandFist" */
        '@fortawesome/free-solid-svg-icons/faHandFist'
    ),
    'flag-checkered': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFlagCheckered" */
        '@fortawesome/free-solid-svg-icons/faFlagCheckered'
    ),
    'frown-open': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFrownOpen" */
        '@fortawesome/free-solid-svg-icons/faFrownOpen'
    ),
    'gift': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGift" */
        '@fortawesome/free-solid-svg-icons/faGift'
    ),
    'golf-ball-tee': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGolfBallTee" */
        '@fortawesome/free-solid-svg-icons/faGolfBallTee'
    ),
    'grin-beam-sweat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGrinBeamSweat" */
        '@fortawesome/free-solid-svg-icons/faGrinBeamSweat'
    ),
    'hamsa': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHamsa" */
        '@fortawesome/free-solid-svg-icons/faHamsa'
    ),
    'hand-back-fist': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandRock" */
        '@fortawesome/free-solid-svg-icons/faHandRock'
    ),
    'hands-asl-interpreting': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandsAslInterpreting" */
        '@fortawesome/free-solid-svg-icons/faHandsAslInterpreting'
    ),
    'hands-bound': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandsBound" */
        '@fortawesome/free-solid-svg-icons/faHandsBound'
    ),
    'hospital-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHospitalWide" */
        '@fortawesome/free-solid-svg-icons/faHospitalWide'
    ),
    'house-damage': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHouseDamage" */
        '@fortawesome/free-solid-svg-icons/faHouseDamage'
    ),
    'house-flood-water': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHouseFloodWater" */
        '@fortawesome/free-solid-svg-icons/faHouseFloodWater'
    ),
    'house-tsunami': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHouseTsunami" */
        '@fortawesome/free-solid-svg-icons/faHouseTsunami'
    ),
    'image-portrait': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPortrait" */
        '@fortawesome/free-solid-svg-icons/faPortrait'
    ),
    'inbox': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faInbox" */
        '@fortawesome/free-solid-svg-icons/faInbox'
    ),
    'kitchen-set': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faKitchenSet" */
        '@fortawesome/free-solid-svg-icons/faKitchenSet'
    ),
    'krw': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWonSign" */
        '@fortawesome/free-solid-svg-icons/faWonSign'
    ),
    'laptop-file': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLaptopFile" */
        '@fortawesome/free-solid-svg-icons/faLaptopFile'
    ),
    'laugh-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLaughBeam" */
        '@fortawesome/free-solid-svg-icons/faLaughBeam'
    ),
    'laugh-wink': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLaughWink" */
        '@fortawesome/free-solid-svg-icons/faLaughWink'
    ),
    'layer-group': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLayerGroup" */
        '@fortawesome/free-solid-svg-icons/faLayerGroup'
    ),
    'less-than': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLessThan" */
        '@fortawesome/free-solid-svg-icons/faLessThan'
    ),
    'line-chart': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLineChart" */
        '@fortawesome/free-solid-svg-icons/faLineChart'
    ),
    'list-numeric': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faListOl" */
        '@fortawesome/free-solid-svg-icons/faListOl'
    ),
    'list-squares': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faListSquares" */
        '@fortawesome/free-solid-svg-icons/faListSquares'
    ),
    'locust': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLocust" */
        '@fortawesome/free-solid-svg-icons/faLocust'
    ),
    'meh-rolling-eyes': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMehRollingEyes" */
        '@fortawesome/free-solid-svg-icons/faMehRollingEyes'
    ),
    'mercury': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMercury" */
        '@fortawesome/free-solid-svg-icons/faMercury'
    ),
    'minus-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMinusCircle" */
        '@fortawesome/free-solid-svg-icons/faMinusCircle'
    ),
    'minus-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareMinus" */
        '@fortawesome/free-solid-svg-icons/faSquareMinus'
    ),
    'mobile-button': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMobileButton" */
        '@fortawesome/free-solid-svg-icons/faMobileButton'
    ),
    'mountain-city': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMountainCity" */
        '@fortawesome/free-solid-svg-icons/faMountainCity'
    ),
    'oil-well': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faOilWell" */
        '@fortawesome/free-solid-svg-icons/faOilWell'
    ),
    'pencil': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPencilAlt" */
        '@fortawesome/free-solid-svg-icons/faPencilAlt'
    ),
    'people-group': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPeopleGroup" */
        '@fortawesome/free-solid-svg-icons/faPeopleGroup'
    ),
    'person-chalkboard': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonChalkboard" */
        '@fortawesome/free-solid-svg-icons/faPersonChalkboard'
    ),
    'person-through-window': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonThroughWindow" */
        '@fortawesome/free-solid-svg-icons/faPersonThroughWindow'
    ),
    'person-walking-with-cane': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonWalkingWithCane" */
        '@fortawesome/free-solid-svg-icons/faPersonWalkingWithCane'
    ),
    'plane-circle-exclamation': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlaneCircleExclamation" */
        '@fortawesome/free-solid-svg-icons/faPlaneCircleExclamation'
    ),
    'plane-circle-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlaneCircleXmark" */
        '@fortawesome/free-solid-svg-icons/faPlaneCircleXmark'
    ),
    'play': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlay" */
        '@fortawesome/free-solid-svg-icons/faPlay'
    ),
    'plug-circle-minus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlugCircleMinus" */
        '@fortawesome/free-solid-svg-icons/faPlugCircleMinus'
    ),
    'plug-circle-plus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlugCirclePlus" */
        '@fortawesome/free-solid-svg-icons/faPlugCirclePlus'
    ),
    'plus-minus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlusMinus" */
        '@fortawesome/free-solid-svg-icons/faPlusMinus'
    ),
    'podcast': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPodcast" */
        '@fortawesome/free-solid-svg-icons/faPodcast'
    ),
    'portrait': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPortrait" */
        '@fortawesome/free-solid-svg-icons/faPortrait'
    ),
    'pump-medical': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPumpMedical" */
        '@fortawesome/free-solid-svg-icons/faPumpMedical'
    ),
    'radiation': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRadiation" */
        '@fortawesome/free-solid-svg-icons/faRadiation'
    ),
    'radio': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRadio" */
        '@fortawesome/free-solid-svg-icons/faRadio'
    ),
    'registered': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRegistered" */
        '@fortawesome/free-solid-svg-icons/faRegistered'
    ),
    'reply-all': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faReplyAll" */
        '@fortawesome/free-solid-svg-icons/faReplyAll'
    ),
    'rmb': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faYenSign" */
        '@fortawesome/free-solid-svg-icons/faYenSign'
    ),
    'rod-snake': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStaffSnake" */
        '@fortawesome/free-solid-svg-icons/faStaffSnake'
    ),
    'ruler-horizontal': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRulerHorizontal" */
        '@fortawesome/free-solid-svg-icons/faRulerHorizontal'
    ),
    'sad-tear': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSadTear" */
        '@fortawesome/free-solid-svg-icons/faSadTear'
    ),
    'school-circle-exclamation': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSchoolCircleExclamation" */
        '@fortawesome/free-solid-svg-icons/faSchoolCircleExclamation'
    ),
    'share-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faShareNodes" */
        '@fortawesome/free-solid-svg-icons/faShareNodes'
    ),
    'shield-heart': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faShieldHeart" */
        '@fortawesome/free-solid-svg-icons/faShieldHeart'
    ),
    'signature': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSignature" */
        '@fortawesome/free-solid-svg-icons/faSignature'
    ),
    'sort-alpha-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortAlphaDown" */
        '@fortawesome/free-solid-svg-icons/faSortAlphaDown'
    ),
    'sort-numeric-asc': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortNumericDown" */
        '@fortawesome/free-solid-svg-icons/faSortNumericDown'
    ),
    'space-shuttle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSpaceShuttle" */
        '@fortawesome/free-solid-svg-icons/faSpaceShuttle'
    ),
    'strikethrough': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStrikethrough" */
        '@fortawesome/free-solid-svg-icons/faStrikethrough'
    ),
    'suitcase-medical': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSuitcaseMedical" */
        '@fortawesome/free-solid-svg-icons/faSuitcaseMedical'
    ),
    'swimming-pool': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWaterLadder" */
        '@fortawesome/free-solid-svg-icons/faWaterLadder'
    ),
    'table': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTable" */
        '@fortawesome/free-solid-svg-icons/faTable'
    ),
    'table-columns': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTableColumns" */
        '@fortawesome/free-solid-svg-icons/faTableColumns'
    ),
    'tasks-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTasksAlt" */
        '@fortawesome/free-solid-svg-icons/faTasksAlt'
    ),
    'temperature-half': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThermometerHalf" */
        '@fortawesome/free-solid-svg-icons/faThermometerHalf'
    ),
    'thumb-tack': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThumbtack" */
        '@fortawesome/free-solid-svg-icons/faThumbtack'
    ),
    'ticket-simple': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTicketSimple" */
        '@fortawesome/free-solid-svg-icons/faTicketSimple'
    ),
    'toilet-paper-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faToiletPaperSlash" */
        '@fortawesome/free-solid-svg-icons/faToiletPaperSlash'
    ),
    'train-subway': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTrainSubway" */
        '@fortawesome/free-solid-svg-icons/faTrainSubway'
    ),
    'trowel': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTrowel" */
        '@fortawesome/free-solid-svg-icons/faTrowel'
    ),
    'truck': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTruck" */
        '@fortawesome/free-solid-svg-icons/faTruck'
    ),
    'truck-moving': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTruckMoving" */
        '@fortawesome/free-solid-svg-icons/faTruckMoving'
    ),
    'undo-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUndoAlt" */
        '@fortawesome/free-solid-svg-icons/faUndoAlt'
    ),
    'up-right-and-down-left-from-center': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUpRightAndDownLeftFromCenter" */
        '@fortawesome/free-solid-svg-icons/faUpRightAndDownLeftFromCenter'
    ),
    'users-gear': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUsersGear" */
        '@fortawesome/free-solid-svg-icons/faUsersGear'
    ),
    'venus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVenus" */
        '@fortawesome/free-solid-svg-icons/faVenus'
    ),
    'video-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVideoSlash" */
        '@fortawesome/free-solid-svg-icons/faVideoSlash'
    ),
    'volume-mute': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVolumeXmark" */
        '@fortawesome/free-solid-svg-icons/faVolumeXmark'
    ),
    'wand-magic': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWandMagic" */
        '@fortawesome/free-solid-svg-icons/faWandMagic'
    ),
    'wifi-3': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWifiStrong" */
        '@fortawesome/free-solid-svg-icons/faWifiStrong'
    ),
    'window-close': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWindowClose" */
        '@fortawesome/free-solid-svg-icons/faWindowClose'
    ),
    'xmark-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faXmarkCircle" */
        '@fortawesome/free-solid-svg-icons/faXmarkCircle'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>